export function getHighlightForCategory(category) {
  return 'usdata' === category ? 'United States' : 'World';
}

export function getLastSegment(path) {
  return path
    .split('/')
    .filter((segment) => segment)
    .pop();
}

export default {
  getHighlightForCategory,
  getLastSegment,
};



// WEBPACK FOOTER //
// ./app/services/tableRowHelpers.js